/*
 * @Description: 微波遥感特征数据检索
 * @Author: JokerShaw
 * @Date: 2023-06-07 13:49:31
 * @LastEditTime: 2023-07-07 16:58:19
 * @FilePath: \yd_yg_test_project_new\src\components\Pages\SearchOfMicrRomoteSensing\index.js
 */
import React, { Component } from 'react'
import { connect } from 'react-redux';
import axios from 'axios'
import qs from 'qs'
// import moment from 'moment'
import './index.css'
import Header4 from 'src/components/Header/Header4';
import { Radio, Checkbox, Pagination, Select, Modal, message, Slider, TreeSelect, Tree, Button } from 'antd';
import ISARDetailModal from './ISARDetailModal/ISARDetailModal';
import ScatterDetailModal from './ScatterDetailModal/ScatterDetailModal';
import tips from './static/tips.png'
import refresh from './static/refresh.png'
import download from './static/download.png'
import nodata from './static/nodata.png'
import testImg from './static/test.png'
import detailed from './static/detailed.png'
import DownloadFileComponent from './Public/downFileComponent'
import './ISARDetailModal/ISARDetailModal.css'
import './ScatterDetailModal/ScatterDetailModal.css'
import closeImg from "./static/closeImg.png";
import ScatterChart from "./ScatterDetailModal/ScatterChart";


const { TreeNode } = Tree
const { Option } = Select;
const CheckboxGroup = Checkbox.Group
const TargetSceneTypeMap = new Map()//用来存储目标场景类型及库表名  结构{"草地" -> "lamp_grass_attribute"}
class SearchOfMicrRomoteSensing extends Component {

    state = {

        targetSceneTypeMap: [],//存储从数据库查询的目标和场景类型
        targetSceneNameMap: [],////存储从数据库查询的目标和场景名称
        targetSceneDescriptionMap: [],//存储从数据库查询的目标和场景描述
        targetSceneType: undefined,//目标或场景类型
        targetSceneName: undefined,//目标或场景名称
        targetSceneDescription: undefined,//目标或场景描述
        isIsarRadioChecked: true,//记录ISAR选择框的状态，初始设置为已选择
        isScatterRadioChecked: true,//记录Scatter选择框的状态，初始设置为已选择
        waveBand: [],//波段
        productsLevel: [],//产品级别
        transceiverMode: undefined,//收发模式
        incidenceAngle: [30, 60],//入射角
        azimuthAngle: [-180, 180],//方位角
        micrRomoteSensingList: [],//存储检索到的数据列表
        isVisible: false,//是否显示数据详情弹窗
        currentPageNumber: 1,//当前页码
        searchResultTotalNum: 0,//检索到的数据数量
        indeterminate: false,//全选按钮的中间状态
        isCheckedTotalData: false,//是否全选中
        sensingCheckedList: [],//选中欲下载的微波遥感特征数据
        sensingItemThumbnailsPathList: {},//检索数据项中缩略图地址列表
        currentCheckUpItem: {},//当前选择查看详情的数据项
        paramsComparisionTable: {},//属性对照表

        isDownloadModalShown: false,
        downloadList: [],
        downLoadTotalScore: 0,
        userScore: 0,

        selectTheComparisonList: [],//选中用于对比的列表
        compareModalVisible: false,
    }

    componentDidMount() {
        this.getAllMicroRSMap()
        this.getDiffTypeDataScore()
        this.getFieldComparison()
        this.getUserScore()
    }

    componentDidUpdate(preProps, preState) {
        // console.log('componentDidUpdate')
        if (preProps.zd_user.token !== this.props.zd_user.token) {
            this.getAllMicroRSMap()
            this.getFieldComparison()
            this.getUserScore()
        }
    }

    getDiffTypeDataScore = async () => {
        const { data: res } = await axios.get(global.gatewayip + '/api/score/type/getByResourceType?resourceType=微波遥感特征数据')
        // console.log('getDiffTypeDataScore---', res)
        if (res.code === '200') {
            this.setState({
                downLoadTotalScore: res.payload.downloadScore
            })
        } else {
            message.error('微波遥感特征数据积分获取失败!')
        }
    }

    getUserScore = async () => {
        if (!this.props.user.userId) return
        axios({
            url: global.url.score + '/score/getbyid',
            method: 'get',
            params: {
                userId: this.props.user.userId,
            },
            headers: {
                'Authorization': this.props.user.token
            }
        }).then(res => {
            // console.log("getUserScore", res)
            if (res.data.code === '200' && res.data.payload) {
                this.setState({ userScore: res.data.payload.score })
            } else {
                message.error('用户积分查询错误或用户积分不存在');
            }
        }).catch(err => {
            console.log(err);
            message.error('用户积分查询错误或用户积分不存在');
        })
    }

    /**
     * @description: 通过数据库查询目标和场景类型
     * @event: getAllMicroRSMap
     * @return {*}
     */
    getAllMicroRSMap = async () => {
        const { zd_user } = this.props;
        const { data: res } = await axios.get('/zdUrl/api/getAllMicroRSMap', {
            headers: {
                Authorization: zd_user.token,
            }
        })
        // console.log('查询属性：',res);
        if (res.code === '0') {
            this.setState({
                targetSceneTypeMap: res.data
            })
        }
    }
    /**
     * @description: 获取属性对照表
     * @event: getFieldComparison
     * @return {*}
     */
    getFieldComparison = async () => {
        const { zd_user } = this.props;
        const { data: res } = await axios.get('/zdUrl/api/getFieldComparison', {
            headers: {
                Authorization: zd_user.token,
            }
        })
        if (res.code === '0') {
            this.setState({
                paramsComparisionTable: res.data
            })
        }
    }
    /**
     * @description: 通过循环生成TreeSelect的根节点
     * @event:
     * @return {*}
     */
    renderTargetSecenTreeNode = () => {
        let treeNode = []
        this.state.targetSceneTypeMap.map((element, index) => {
            treeNode.push(
                <TreeNode
                    value={element.dataType}
                    key={element.dataType}
                    title={element.dataType}
                    selectable={false}
                >
                    {this.renderTargetSecenTreeLeaf(element.microRSMetaList)}
                </TreeNode>
            )
        })
        return treeNode
    }
    /**
     * @description: 通过循环生成TreeSelect的叶节点
     * @event:
     * @return {*}
     */
    renderTargetSecenTreeLeaf = (treeLeafList) => {
        let leafNode = []
        if (treeLeafList) {
            treeLeafList.map((element, index) => {
                if (!TargetSceneTypeMap.has(element.tableName)) {
                    TargetSceneTypeMap.set(element.sampleClass, element.tableName)
                }
                leafNode.push(
                    <TreeNode
                        value={element.sampleClass}
                        key={element.sampleClass}
                        title={element.sampleClass}
                        isLeaf={true}
                    >
                    </TreeNode>
                )
            })
        }
        return leafNode
    }

    /**
     * @description: 通过数据库接口获取目标或场景名称
     * @event:
     * @return {*}
     */
    getSampleSubclassbySampleClass = async (targetSceneType) => {
        const { zd_user } = this.props
        const { data: res } = await axios.get(`/zdUrl/api/getSampleSubclassbySampleClass?SampleClass=${targetSceneType}`, {
            headers: {
                Authorization: zd_user.token,
            }
        })
        // console.log(res)
        if (res.code === "0") {
            this.setState({
                targetSceneNameMap: res.data
            })
        }
    }

    /**
     * @description: 通过数据库接口获取目标和场景描述
     * @event:
     * @return {*}
     */
    getSampleFeaturesbySampleSubclass = async (targetSceneType, targetSceneName) => {
        const { zd_user } = this.props
        const { data: res } = await axios.get(`/zdUrl/api/getSampleFeaturesbySampleSubclass?sampleClass=${targetSceneType}&SampleSublass=${targetSceneName}`, {
            headers: {
                Authorization: zd_user.token,
            }
        })
        if (res.code === '0') {
            this.setState({
                targetSceneDescriptionMap: res.data
            })
        }
        console.log(res.data)
    }

    /**
     * @description: 通过数据库检索接口获取微波遥感特征数据检索结果
     * @event:
     * @return {*}
     */
    SearchMicrRomoteSensing = async () => {
        if (!this.state.targetSceneType) {
            message.error("请选择目标或场景类型")
        } else if (!this.state.targetSceneName) {
            message.error("请选择目标或场景名称")
        } else if (!this.state.isIsarRadioChecked && !this.state.isScatterRadioChecked) {
            message.error("请至少选择一个产品类型（ISAR影像产品或者散射数据产品）")
        } else {
            const { isScatterRadioChecked, isIsarRadioChecked, waveBand } = this.state
            const { zd_user } = this.props
            let bandArray = []
            waveBand.map(element => {
                if (element) {
                    bandArray.push(element.substring(0, 1))
                }
            })
            console.log('ceshi', TargetSceneTypeMap)
            let searchParams = {
                startAzimuthAngle: this.state.azimuthAngle[0],
                endAzimuthAngle: this.state.azimuthAngle[1],
                startIncidenceAngle: this.state.incidenceAngle[0],
                endIncidenceAngle: this.state.incidenceAngle[1],
                startMeasureDate: -1,
                endMeasureDate: -1,
                featureTypes: TargetSceneTypeMap.get(this.state.targetSceneType),
                num: 10,
                page: this.state.currentPageNumber,
                productLevel: this.state.productsLevel,
                sampleClass: this.state.targetSceneType,
                sampleSubclass: this.state.targetSceneName,
                sampleFeatures: this.state.targetSceneDescription,
                tRMode: this.state.transceiverMode,
                productType: isIsarRadioChecked && isScatterRadioChecked ? 0 : isIsarRadioChecked && !isScatterRadioChecked ? 1 : 2,
                band: bandArray
            }
            // console.log(qs.stringify(searchParams,{arrayFormat: 'repeat'}))
            // console.log(qs.parse(searchParams))
            // console.log(zd_user.token)
            let params = qs.stringify(qs.parse(searchParams), { indices: false })
            // console.log(params)
            // 接口报错404
            const { data: res } = await axios.get(`/zdTiles/api/MicroRSFeatureData?${params}`, {
                // params,
                headers: {
                    Authorization: zd_user.token,
                }
            })
            console.log('查询到的数据：', res)
            if (res.code === '0' && res.data.list.length !== 0) {
                let dataNamesArray = []
                res.data.list.map(element => {
                    dataNamesArray.push(element.product_name + '.zip')
                })
                this.setState({
                    micrRomoteSensingList: res.data.list,
                    searchResultTotalNum: res.data.total
                })
                this.getMicroRSFeatureGraphicPath(dataNamesArray, res.data.list[0].sample_photo_file_location.replace(/\\/g, '%5C'))
            } else if (!res.data || res.data.list.length === 0) {
                message.warning("查询到 0 条数据")
                this.setState({ micrRomoteSensingList: [], searchResultTotalNum: 0 })
            } else {
                message.error("查询失败，请重试！")
            }
        }
    }
    /**
     * @description: 通过浙大接口查询样本缩略图预览地址
     * @event: getMicroRSFeatureGraphicPath
     * @return {*}
     */
    getMicroRSFeatureGraphicPath = async (dataNamesArray, dataPath) => {
        const { zd_user } = this.props
        const { data: res } = await axios.get(`/zdUrl/api/getMicroRSFeatureGraphicPath?dataNames=${dataNamesArray}&dataPath=${dataPath}`, {
            headers: {
                Authorization: zd_user.token,
            }
        })
        // console.log(res)
        if (res.code === "0") {
            this.setState({
                sensingItemThumbnailsPathList: res.data
            }, () => {
                console.log(this.state.sensingItemThumbnailsPathList)
            })
        }
    }
    /**
     * @description: 分页查询数据
     * @event:
     * @return {*}
     */
    changePaginationNumber = (pageNUm) => {
        this.setState({
            currentPageNumber: pageNUm,
            isCheckedTotalData: false,
            indeterminate: false
        }, () => {
            this.SearchMicrRomoteSensing()
        })
    }
    /**
     * @description: 改变产品类型
     * @event:
     * @return {*}
     * 1、基于Web球的3-5级产品可视化展示
     * 在调用GeoServer服务的基础上，基于Web球进行水体专题、林业专题、农业专题等产品可视化渲染，实现专题产品按时间序列进行加载展示，进而开展产品可视化对比分析；
     * 2、界面重构
     * 根据用户新的需求，采用媒体查询、响应式布局的方式对界面进行重构，同时对相应功能进行完善
     */
    // 改变产品类型
    changeProductType = (checkedType, event) => {
        switch (checkedType) {
            case 'ISAR':
                // console.log(event.target.value)
                this.setState({
                    isIsarRadioChecked: !this.state.isIsarRadioChecked
                }, () => {
                    if (!this.state.isIsarRadioChecked) {
                        this.setState({
                            waveBand: []
                        })
                    }
                })
                break;
            case "scatter":
                // console.log(value)
                this.setState({
                    isScatterRadioChecked: !this.state.isScatterRadioChecked
                })
            default:
                break;
        }
    }

    // 改变select选择的数据
    changeSelectValue = (selectName, selectValue) => {
        console.log(selectName, "    ", selectValue)
        switch (selectName) {
            case '目标或场景类型':
                this.shownTRModeArea(selectValue)
                this.getSampleSubclassbySampleClass(selectValue)
                this.setState({
                    targetSceneType: selectValue,
                    targetSceneName: undefined,
                    targetSceneDescription: undefined
                })
                break;
            case '目标或场景名称':
                this.getSampleFeaturesbySampleSubclass(this.state.targetSceneType, selectValue)
                this.setState({
                    targetSceneName: selectValue,
                    targetSceneDescription: undefined
                })
                break;
            case '目标或场景描述':
                this.setState({
                    targetSceneDescription: selectValue
                })
                break;
            case '波段':
                this.setState({
                    waveBand: selectValue
                })
                break;
            case '产品级别':
                this.setState({
                    productsLevel: selectValue
                })
                break;
            case '收发模式':
                this.setState({
                    transceiverMode: selectValue
                })
                break;
            case '入射角':
                this.setState({
                    incidenceAngle: selectValue
                })
                break;
            case '方位角':
                this.setState({
                    azimuthAngle: selectValue
                })
                break;
            default:
                break;
        }
    }
    /**
     * @description: 全选和取消全选
     * @event:
     * @return {*}
     */
    checkedTotalsensingData = (event) => {
        this.setState({
            sensingCheckedList: event.target.checked ? this.state.micrRomoteSensingList : [],
            indeterminate: false,
            isCheckedTotalData: event.target.checked
        })
    }
    /**
     * @description: 选中微波遥感特征数据item项
     * @event:
     * @return {*}
     */
    changeCheckList = (checkList) => {
        console.log("检查选中列表：", checkList);
        this.setState({ selectTheComparisonList: checkList.slice(0, 2) })

        this.setState({
            sensingCheckedList: checkList,
            indeterminate: checkList.length && checkList.length < this.state.micrRomoteSensingList.length,
            isCheckedTotalData: checkList.length === this.state.micrRomoteSensingList.length
        })
    }
    resetSearchConditions = () => {
        this.setState({
            targetSceneType: undefined,//目标或场景类型
            targetSceneName: undefined,//目标或场景名称
            targetSceneDescription: undefined,//目标或场景描述
            isIsarRadioChecked: true,//记录ISAR选择框的状态，初始设置为已选择
            isScatterRadioChecked: true,//记录Scatter选择框的状态，初始设置为已选择
            waveBand: [],//波段
            productsLevel: [],//产品级别
            transceiverMode: undefined,//收发模式
            incidenceAngle: [30, 60],//入射角
            azimuthAngle: [-180, 180],//方位角
            micrRomoteSensingList: [],//存储检索到的数据列表
        })
    }

    shownTRModeArea = (selectValue) => {
        if (selectValue === "水体场景") {
            document.getElementById('sensing-search-interface-other-attributes-area').style.height = '193px'
            document.getElementById('sensing-search-interface-search-content').style.height = '682px'
            document.getElementById('sensing-search-interface-TRmode-area').setAttribute('style', 'display:block')
            // changeTRModeStatus = !changeTRModeStatus
        } else {
            document.getElementById('sensing-search-interface-other-attributes-area').style.height = '132px'
            document.getElementById('sensing-search-interface-search-content').style.height = '621px'
            document.getElementById('sensing-search-interface-TRmode-area').setAttribute('style', 'display:none')
            // changeTRModeStatus = !changeTRModeStatus
        }
    }

    openDetailModal = (checkUpValue) => {
        this.setState({
            isVisible: true,
            currentCheckUpItem: checkUpValue
        })
    }

    closeDetailModal = () => {
        this.setState({
            isVisible: false
        })
    }

    closeDownLoadModal = () => {
        this.setState({
            isDownloadModalShown: false,
        })
    }

    downloadSingleAlgorithm = (downItem) => {
        console.log("downItem", downItem)
        downItem.score = this.state.downLoadTotalScore
        this.setState({
            downloadList: [downItem],
            downLoadTotalScore: downItem.score,
            isDownloadModalShown: true
        })
    }

    loadCompareModal = () => {
        let { selectTheComparisonList } = this.state;
        // console.log('selectTheComparisonList:', selectTheComparisonList)
        return selectTheComparisonList.map(
            item =>
                item.product_type === 'ISAR' ?
                    <>
                        <ISARDetailModal
                            selcetItem={item}
                            isVisible={this.state.isVisible}
                            closeDetailModal={() => this.closeDetailModal()}
                            samplePropetyComparision={this.state.paramsComparisionTable[TargetSceneTypeMap.get(this.state.targetSceneType)]}
                            productPropetyComparision={this.state.paramsComparisionTable.lamp_isar_prod}
                        ></ISARDetailModal>
                    </>
                    :
                    item.product_type === "Scatter" ?
                        <>
                            <ScatterDetailModal
                                selcetItem={item}
                                isVisible={this.state.isVisible}
                                closeDetailModal={() => this.closeDetailModal()}
                                samplePropetyComparision={this.state.paramsComparisionTable[TargetSceneTypeMap.get(this.state.targetSceneType)]}
                                productPropetyComparision={this.state.paramsComparisionTable.lamp_scatter_prod}
                            ></ScatterDetailModal>
                        </>
                        :
                        <></>
        )
    }


    render() {

        let { selectTheComparisonList, compareModalVisible } = this.state;

        // 产品级别
        let productsLevelTreeData = [
            {
                value: 'ISAR',
                title: 'ISAR',
                disabled: true,
                children: [
                    // {
                    //     value: 'M1A',
                    //     title: 'M1A',
                    //     disabled: !this.state.isIsarRadioChecked
                    // },
                    {
                        value: 'M1B',
                        title: 'M1B',
                        disabled: !this.state.isIsarRadioChecked
                    }
                ]
            },
            {
                value: '散射',
                title: '散射',
                disabled: true,
                children: [
                    {
                        value: 'S1B',
                        title: 'S1B',
                        disabled: !this.state.isScatterRadioChecked
                    },
                    // {
                    //     value: 'S1C',
                    //     title: 'S1C',
                    //     disabled: !this.state.isScatterRadioChecked
                    // }
                ]
            }
        ]

        // 收发模式
        let transceiverModeOptions = [
            {
                value: '单站',
                title: '单站',
            },
            {
                value: '双站',
                title: '双站',
            }
        ]

        // 波段
        let waveBandOptions = [
            {
                value: 'L波段@1.26GHz',
                title: 'L波段@1.26GHz',
            },
            {
                value: 'S波段@3.2GHz',
                title: 'S波段@3.2GHz',
            },
            {
                value: 'C波段@5.3GHz',
                title: 'C波段@5.3GHz',
            },
            {
                value: 'X波段@9.6GHz',
                title: 'X波段@9.6GHz',
            },
            {
                value: 'Ku波段@15GHz',
                title: 'Ku波段@15GHz',
            },
        ]

        return (
            <div>
                <Header4></Header4>
                {/*多选对比对话框*/}
                <Modal className="compare_modal" visible={compareModalVisible}
                    header={null}
                    closable={false}
                    destroyOnClose
                    footer={null}
                >
                    <div className="isar-detail-display-modal-hedar-wrap">
                        <div
                            className="isar-detail-display-modal-hedar-title">{selectTheComparisonList[0] && selectTheComparisonList[0].product_type === 'ISAR' ? "ISAR影像" : "散射"}产品对比
                        </div>
                        <img src={closeImg} className="isar-detail-display-modal-hedar-closeImg"
                            onClick={() => this.setState({ compareModalVisible: false, selectTheComparisonList: [] })}
                            alt=""></img>
                    </div>
                    <div className="compare_modal_content">
                        {
                            this.loadCompareModal()
                        }
                    </div>

                </Modal>


                {/* 界面背景 */}
                <div className="sensing-search-interface-background">
                    {/* 界面检索条件及检索结果区域 */}
                    <div className="sensing-search-interface-content">
                        {/* 界面左侧检索条件区域 */}
                        <div className="sensing-search-interface-search-content"
                            id="sensing-search-interface-search-content">
                            {/* 头部检索标题栏 */}
                            <div className="sensing-search-interface-search-title-wrap">
                                <div className="sensing-search-interface-search-title-text">微波遥感特征库检索</div>
                                <div className="sensing-search-interface-search-title-abillity-wrap">
                                    <img
                                        title="点击获取微波遥感特征数据介绍"
                                        src={tips}
                                        className="sensing-search-interface-search-title-tip"
                                        onClick={() => this.shownTRModeArea()}
                                    ></img>
                                    <div className="sensing-search-interface-search-title-reset-wrap" onClick={() => {
                                        this.resetSearchConditions()
                                    }}>
                                        <img src={refresh}
                                            className="sensing-search-interface-search-title-reset-img"></img>
                                        <div className="sensing-search-interface-search-title-reset-text">重置条件</div>
                                    </div>
                                </div>
                            </div>
                            {/* 地物类型选择区域 */}
                            <div className="sensing-search-interface-surface-features-wrap">
                                <TreeSelect
                                    allowClear
                                    className="sensing-search-interface-features-base-class"
                                    placeholder="目标或场景类型"
                                    treeDefaultExpandAll
                                    getPopupContainer={triggerNode => {
                                        return triggerNode.parentNode
                                    }}
                                    value={this.state.targetSceneType}
                                    onChange={(value) => {
                                        this.changeSelectValue("目标或场景类型", value)
                                    }}
                                >
                                    {this.renderTargetSecenTreeNode()}
                                </TreeSelect>
                                <Select
                                    allowClear
                                    className="sensing-search-interface-features-class"
                                    placeholder="目标或场景名称"
                                    getPopupContainer={triggerNode => {
                                        return triggerNode.parentNode
                                    }}
                                    value={this.state.targetSceneName}
                                    onChange={(value) => {
                                        this.changeSelectValue("目标或场景名称", value)
                                    }}
                                >
                                    {
                                        this.state.targetSceneNameMap.map((element, index) => {
                                            return <Option value={element}
                                                key={`${element}-${index}`}>{element}</Option>
                                        })
                                    }
                                </Select>
                                <Select
                                    allowClear
                                    className="sensing-search-interface-features-peculiarity"
                                    placeholder="目标或场景描述"
                                    getPopupContainer={triggerNode => {
                                        return triggerNode.parentNode
                                    }}
                                    value={this.state.targetSceneDescription}
                                    onChange={(value) => {
                                        this.changeSelectValue("目标或场景描述", value)
                                    }}
                                >
                                    {
                                        this.state.targetSceneDescriptionMap.map((element, index) => {
                                            if (element) return <Option value={element}
                                                key={`${element}-${index}`}>{element}</Option>
                                        })
                                    }
                                </Select>
                            </div>
                            {/* 产品类型选择区(ISAR或者Scatter) */}
                            <div className="sensing-search-interface-product-type-wrap">
                                <Radio
                                    className={this.state.isIsarRadioChecked ? "sensing-search-interface-isar-product-radio-checked" : "sensing-search-interface-isar-product-radio"}
                                    value={'ISAR'}
                                    checked={this.state.isIsarRadioChecked}
                                    onClick={(event) => {
                                        this.changeProductType('ISAR', event)
                                    }}
                                >
                                    <div className="sensing-search-interface-isar-product-text">ISAR影像产品</div>
                                </Radio>
                                <Radio
                                    className={this.state.isScatterRadioChecked ? "sensing-search-interface-scatter-product-radio-checked" : "sensing-search-interface-scatter-product-radio"}
                                    value={'scatter'}
                                    checked={this.state.isScatterRadioChecked}
                                    onClick={(event) => {
                                        this.changeProductType('scatter', event)
                                    }}
                                >
                                    <div className="sensing-search-interface-scatter-product-text">散射数据产品</div>
                                </Radio>
                            </div>
                            {/* 波段、产品级别、收发模式区 */}
                            <div className="sensing-search-interface-other-attributes-area"
                                id="sensing-search-interface-other-attributes-area">
                                {/* 波段 */}
                                <div className="sensing-search-interface-band-area">
                                    <div
                                        className={!this.state.isIsarRadioChecked ? "sensing-search-interface-band-title-disabled" : "sensing-search-interface-band-title"}>波段
                                    </div>
                                    <Select
                                        mode="multiple"
                                        showSearch={false}
                                        showArrow
                                        maxTagCount={2}
                                        allowClear
                                        placeholder="全部"
                                        className="sensing-search-interface-band-select"
                                        disabled={!this.state.isIsarRadioChecked}
                                        options={waveBandOptions}
                                        getPopupContainer={triggerNode => {
                                            return triggerNode.parentNode
                                        }}
                                        value={this.state.waveBand}
                                        onChange={(value) => {
                                            this.changeSelectValue("波段", value)
                                        }}
                                    ></Select>
                                </div>
                                {/* 产品级别 */}
                                <div className="sensing-search-interface-productlevel-area">
                                    <div className="sensing-search-interface-productlevel-title">产品级别</div>
                                    <TreeSelect
                                        showArrow
                                        showSearch={false}
                                        multiple
                                        allowClear
                                        placeholder="全部"
                                        className="sensing-search-interface-productlevel-select"
                                        treeDefaultExpandAll
                                        treeData={productsLevelTreeData}
                                        getPopupContainer={triggerNode => {
                                            return triggerNode.parentNode
                                        }}
                                        value={this.state.productsLevel}
                                        onChange={(value) => {
                                            this.changeSelectValue("产品级别", value)
                                        }}
                                    ></TreeSelect>
                                </div>
                                {/* 收发模式 */}
                                <div className="sensing-search-interface-TRmode-area"
                                    id="sensing-search-interface-TRmode-area" style={{ display: 'none' }}>
                                    <div className="sensing-search-interface-TRmode-title">收发模式</div>
                                    <Select
                                        allowClear
                                        placeholder="全部"
                                        className="sensing-search-interface-TRmode-select"
                                        options={transceiverModeOptions}
                                        getPopupContainer={triggerNode => {
                                            return triggerNode.parentNode
                                        }}
                                        value={this.state.transceiverMode}
                                        onChange={(value) => {
                                            this.changeSelectValue("收发模式", value)
                                        }}
                                    ></Select>
                                </div>
                            </div>
                            {/* 入射角和方位角 */}
                            <div className="sensing-search-interface-angle-area">
                                {/* 入射角 */}
                                <div className="sensing-search-interface-incidence-angle-area">
                                    <div className="sensing-search-interface-incidence-angle-text">入射角</div>
                                    <Slider
                                        className="sensing-search-interface-incidence-angle-slider"
                                        range
                                        defaultValue={[30, 60]}
                                        tooltipVisible={true}
                                        getTooltipPopupContainer={triggerNode => {
                                            return triggerNode.parentNode
                                        }}
                                        // tooltip={{
                                        //   open: true,
                                        //   getPopupContainer:triggerNode=>{return triggerNode.parentNode}
                                        // }}
                                        max={90}
                                        min={0}
                                        value={this.state.incidenceAngle}
                                        onChange={(value) => {
                                            this.changeSelectValue("入射角", value)
                                        }}
                                    ></Slider>
                                </div>
                                {/* 方位角 */}
                                <div className="sensing-search-interface-azimuth-angle-area">
                                    <div className="sensing-search-interface-azimuth-angle-text">方位角</div>
                                    <Slider
                                        className="sensing-search-interface-azimuth-angle-slider"
                                        range
                                        defaultValue={[-180, 180]}
                                        tooltipVisible={true}
                                        getTooltipPopupContainer={triggerNode => {
                                            return triggerNode.parentNode
                                        }}
                                        // tooltip={{
                                        //   open: true,
                                        //   getPopupContainer:triggerNode=>{return triggerNode.parentNode}
                                        // }}
                                        max={180}
                                        min={-180}
                                        value={this.state.azimuthAngle}
                                        onChange={(value) => this.changeSelectValue("方位角", value)}
                                    ></Slider>
                                </div>
                            </div>
                            <div className="sensing-search-interface-search-button-wrap">
                                <div className="sensing-search-interface-search-button"
                                    onClick={() => this.SearchMicrRomoteSensing()}>检索
                                </div>
                            </div>
                        </div>
                        {/* 界面右侧检索结果区域 */}
                        <div className="sensing-search-interface-result-content">
                            {/* 结果区头部 */}
                            <div className="sensing-search-interface-result-content-title-wrap">
                                <div className="sensing-search-interface-result-content-title-text">微波遥感特征库</div>
                                {/* 特征数据的下载功能暂时先不要做，该部分数据的下载审核比较严格 */}
                                {/* <div className="sensing-search-interface-result-content-download-botton-wrap">
                  <img src={download} className="sensing-search-interface-result-content-download-img"></img>
                  <div className="sensing-search-interface-result-content-download-text">批量提交下载订单</div>
                </div> */}
                            </div>
                            {/* 全选按钮区 */}
                            {/*
              */}
                            <div className="sensing-search-interface-result-content-checkall-wrap">
                                {/*<Checkbox*/}
                                {/*  className="sensing-search-interface-result-content-checkall-buttom"*/}
                                {/*  indeterminate={this.state.indeterminate}*/}
                                {/*  checked={this.state.isCheckedTotalData}*/}
                                {/*  disabled={this.state.micrRomoteSensingList.length === 0 ? true : false}*/}
                                {/*  onChange={(e)=>{this.checkedTotalsensingData(e)}}*/}
                                {/*>全选</Checkbox>*/}

                                <div
                                    className="sensing-search-interface-result-content-checkall-result">已勾选{this.state.sensingCheckedList.length}条数据(最多勾选2条数据)
                                </div>
                                {/* 对比按钮 */}
                                <Button disabled={selectTheComparisonList.length === 0} type={"primary"}
                                    onClick={() => this.setState({ compareModalVisible: true })}
                                >对比</Button>
                            </div>
                            {/* 检索结果item项 */}
                            <div className="sensing-search-interface-result-content-items-wrap">
                                {
                                    this.state.micrRomoteSensingList.length === 0 ? <>
                                        {/* 无检索结果 */}
                                        <div className="sensing-search-interface-result-nodata-wrap">
                                            <img src={nodata}
                                                className="sensing-search-interface-result-content-nodata-img"></img>
                                        </div>
                                    </> : <>
                                        {/*添加多选并对比*/}
                                        <CheckboxGroup
                                            className="sensing-search-interface-result-content-item-checkbox-group"
                                            value={selectTheComparisonList}
                                            onChange={(value) => {
                                                this.changeCheckList(value)
                                            }}
                                        >
                                            {
                                                this.state.micrRomoteSensingList.map((item, index) => {
                                                    return <div key={index}
                                                        className="sensing-search-interface-result-content-item-checkbox-wrap"
                                                    >
                                                        <Checkbox value={item}
                                                            className="sensing-search-interface-result-content-item-checkbox"
                                                            disabled={selectTheComparisonList.length >= 2 && !selectTheComparisonList.includes(item)}
                                                        ></Checkbox>
                                                        <div
                                                            className="sensing-search-interface-result-content-item-wrap">
                                                            {/* {
                                  // console.log(this.state.sensingItemThumbnailsPathList)
                                } */}
                                                            <img
                                                                src={
                                                                    this.state.sensingItemThumbnailsPathList[item.product_name + '.zip'] ?
                                                                        this.state.sensingItemThumbnailsPathList[item.product_name + '.zip'].replace("http://10.0.121.14:8084", "https://caplos.aircas.ac.cn/zdTiles") :
                                                                        null
                                                                }
                                                                className="sensing-search-interface-result-content-item-img"
                                                            ></img>
                                                            <div
                                                                className="sensing-search-interface-result-content-item-product-wrap">
                                                                <div
                                                                    className="sensing-search-interface-result-content-item-product-name">{item.sample_subclass}</div>
                                                                <div
                                                                    className="sensing-search-interface-result-content-item-product-attributes-wrap">
                                                                    <div
                                                                        className="sensing-search-interface-result-content-item-product-band-wrap">
                                                                        <div
                                                                            className="sensing-search-interface-result-content-item-product-band-text">波段
                                                                        </div>
                                                                        <div
                                                                            className="sensing-search-interface-result-content-item-product-band-value">{item.band}波段
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        className="sensing-search-interface-result-content-item-product-incidence-angle-wrap">
                                                                        <div
                                                                            className="sensing-search-interface-result-content-item-product-incidence-angle-text">入射角
                                                                        </div>
                                                                        <div
                                                                            className="sensing-search-interface-result-content-item-product-incidence-angle-value">{item.center_incidence_angle}</div>
                                                                    </div>
                                                                    <div
                                                                        className="sensing-search-interface-result-content-item-product-azimuth-angle-wrap">
                                                                        <div
                                                                            className="sensing-search-interface-result-content-item-product-azimuth-angle-text">方位角
                                                                        </div>
                                                                        <div
                                                                            className="sensing-search-interface-result-content-item-product-azimuth-angle-value">{item.center_azimuth_angle}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="sensing-search-interface-result-content-item-ability-wrap">
                                                                <div
                                                                    className="sensing-search-interface-result-content-item-detail-button-wrap"
                                                                    onClick={() => this.openDetailModal(item)}
                                                                >
                                                                    <img src={detailed}
                                                                        className="sensing-search-interface-result-content-item-detail-img"></img>
                                                                    <div
                                                                        className="sensing-search-interface-result-content-item-detail-text"
                                                                    >详情
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className="sensing-search-interface-result-content-item-download-button-wrap"
                                                                    onClick={() => {
                                                                        this.downloadSingleAlgorithm(item)
                                                                    }}>
                                                                    <img src={download}
                                                                        className="sensing-search-interface-result-content-item-download-img"></img>
                                                                    <div
                                                                        className="sensing-search-interface-result-content-item-download-text">提交下载订单
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                })
                                            }
                                        </CheckboxGroup>
                                        {/* 页脚区域 */}
                                        <div className="sensing-search-interface-result-pagination-wrap-out">
                                            <div className="sensing-search-interface-result-pagination-wrap-ininer">
                                                <div
                                                    className="sensing-search-interface-result-pagination-totalNum">共{this.state.searchResultTotalNum}条数据
                                                </div>
                                                <Pagination
                                                    showQuickJumper
                                                    showSizeChanger={false}
                                                    total={this.state.searchResultTotalNum}
                                                    current={this.state.currentPageNumber}
                                                    onChange={(value) => {
                                                        this.changePaginationNumber(value)
                                                    }}
                                                    defaultPageSize={10}
                                                    className="sensing-search-interface-result-pagination"
                                                ></Pagination>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <Modal
                    className="isar-detail-display-modal"
                    header={null}
                    visible={this.state.isVisible}
                    footer={null}
                    closable={false}
                >
                    {
                        this.state.currentCheckUpItem.product_type === 'ISAR' ?
                            <>
                                <div className="isar-detail-display-modal-hedar-wrap">
                                    <div className="isar-detail-display-modal-hedar-title">ISAR影像产品详情展示</div>
                                    <img src={closeImg} className="isar-detail-display-modal-hedar-closeImg"
                                        onClick={() => this.closeDetailModal()} alt=""></img>
                                </div>
                                <div className="compare_modal_content">

                                    <ISARDetailModal
                                        selcetItem={this.state.currentCheckUpItem}
                                        isVisible={this.state.isVisible}
                                        closeDetailModal={() => this.closeDetailModal()}
                                        samplePropetyComparision={this.state.paramsComparisionTable[TargetSceneTypeMap.get(this.state.targetSceneType)]}
                                        productPropetyComparision={this.state.paramsComparisionTable.lamp_isar_prod}
                                    ></ISARDetailModal>

                                </div>
                            </>
                            :
                            this.state.currentCheckUpItem.product_type === "Scatter" ?
                                <>
                                    <div className="scatter-detail-display-modal-hedar-wrap">
                                        <div className="scatter-detail-display-modal-hedar-title">散射产品详情展示</div>
                                        <img src={closeImg} className="scatter-detail-display-modal-hedar-closeImg"
                                            onClick={() => this.closeDetailModal()} alt=""></img>
                                    </div>
                                    <ScatterDetailModal
                                        selcetItem={this.state.currentCheckUpItem}
                                        isVisible={this.state.isVisible}
                                        closeDetailModal={() => this.closeDetailModal()}
                                        samplePropetyComparision={this.state.paramsComparisionTable[TargetSceneTypeMap.get(this.state.targetSceneType)]}
                                        productPropetyComparision={this.state.paramsComparisionTable.lamp_scatter_prod}
                                    ></ScatterDetailModal>
                                </>
                                :
                                <></>
                    }
                </Modal>
                <DownloadFileComponent
                    orderList={this.state.downloadList}
                    userScore={this.state.userScore}
                    totalScore={this.state.downLoadTotalScore}
                    resourceType={"微波遥感特征数据"}
                    showDownLoadModalFlag={this.state.isDownloadModalShown}
                    closeDownLoadModal={() => this.closeDownLoadModal()}
                    clearAlgCheckedList={() => this.clearAlgCheckedList()}
                ></DownloadFileComponent>
            </div>
        )
    }
}

const mapState = (state) => ({ //返回值  对应的是  组件的props  
    user: state.userReducer.get('user').toJS(),
    zd_user: state.userReducer.get('zd_user').toJS(),
})
export default connect(mapState)(SearchOfMicrRomoteSensing)